import {
  propertyTypesService,
  type PropertyType,
} from '@/services/property-types';
import { useQuery } from '@tanstack/react-query';

export function usePropertyTypes() {
  return useQuery<PropertyType[]>({
    queryKey: ['property-types'],
    queryFn: async () => {
      const result = await propertyTypesService.getPropertyTypes();

      if (!result.success || !result.data) {
        throw new Error(result.error || 'Erro ao carregar tipos de imóvel');
      }

      return result.data.data;
    },
  });
}
